var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.14258 18.2346C9.14258 17.8001 9.49474 17.448 9.92916 17.448H13.0703C13.5047 17.448 13.8569 17.8001 13.8569 18.2346C13.8569 18.669 13.5047 19.0211 13.0703 19.0211H9.92917C9.49475 19.0211 9.14258 18.669 9.14258 18.2346ZM9.14258 15.0882C9.14258 14.6538 9.49474 14.3016 9.92916 14.3016H16.2131C16.6476 14.3016 16.9997 14.6538 16.9997 15.0882C16.9997 15.5226 16.6476 15.8748 16.2131 15.8748H9.92916C9.49474 15.8748 9.14258 15.5226 9.14258 15.0882ZM9.14258 11.9419C9.14258 11.5074 9.49474 11.1553 9.92916 11.1553H16.2131C16.6476 11.1553 16.9997 11.5074 16.9997 11.9419C16.9997 12.3763 16.6476 12.7284 16.2131 12.7284H9.92916C9.49474 12.7284 9.14258 12.3763 9.14258 11.9419Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 25.3138H7.57143V9.58205H26.4286V17.4479H28V9.58205C28 9.16481 27.8344 8.76468 27.5398 8.46965C27.2451 8.17463 26.8454 8.00888 26.4286 8.00888H7.57143C7.15465 8.00888 6.75496 8.17463 6.46026 8.46965C6.16556 8.76468 6 9.16481 6 9.58205V25.3138C6 25.7311 6.16556 26.1312 6.46026 26.4263C6.75496 26.7212 7.15465 26.887 7.57143 26.887H15.4286V25.3138Z",
    fill: "#D3FF9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7141 24.9913L19.6791 22.954L18.5713 24.063L21.7141 27.2093L27.9999 20.9167L26.8921 19.8076L21.7141 24.9913Z",
    fill: "#D3FF9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.48212 0 10.0111V25.0277C0 30.5567 4.47715 35.0388 10 35.0388H25C30.5228 35.0388 35 30.5567 35 25.0277V10.0111C35 4.48212 30.5228 0 25 0Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/checklist-icon.c467fde9a8876e21448028b8a1e8b83b.svg";
export { ForwardRef as ReactComponent };